import { type ICompanyUserQuery } from 'application/querySchemas/ICompanyUserQuery';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
// import { type ICompanyUserFactory } from 'domain/entities/factories/CompanyUser';
import { type ICompanyCheckTokenClient } from 'interfaceAdapter/gatewaySchemas/ICompanyCheckTokenClient';
import { inject, injectable } from 'tsyringe';

@injectable()
export class CompanyUserQuery implements ICompanyUserQuery {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly token: ICompanyUserTokenRepository,
        @inject('ICompanyCheckTokenClient')
        public readonly checkTokenClient: ICompanyCheckTokenClient,
    ) {
        // @inject('ICompanyUserFactory')
        // public readonly factory: ICompanyUserFactory,
    }

    public checkToken = async (incrementLoginCount: boolean): Promise<any> => {
        const token = this.token.get();
        if (!token) {
            return {
                user: null,
                status: false,
            };
        }
        const { data, status } = await this.checkTokenClient.get({
            token,
            addLoginCount: incrementLoginCount,
        });
        // TODO buildをサボっている
        // return this.factory.build(data);
        return {
            user: data,
            status: status === 'valid',
        };
    };
}
